import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'


const TermsPage = (props) => {

    return (
        <div>
            <Navbar />
            <PageTitle pageTitle={'Terms of Use'} pagesub={'Terms of Use'} />
            <section className="wpo-terms-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="wpo-terms-wrap">
                                <div className="wpo-terms-text">
                                    <h2>Terms of Use - Marsh Events & Training Hub</h2>
                                    <p><strong>Last Updated: October 2025</strong></p>
                                    <p>Welcome to Marsh Events & Training Hub. By accessing and using our website and services, you agree to comply with and be bound by the following terms and conditions. Please read these terms carefully before registering for any courses or events.</p>
                                    
                                    <h3>Course Registration and Payment</h3>
                                    <p>When you register for our training programs or events, you agree to the following:</p>

                                    <ul>
                                        <li>All course fees must be paid in full before the commencement of the training program.</li>
                                        <li>Registration confirmations will be sent via email to the address provided during booking.</li>
                                        <li>Prices are subject to change without prior notice, but confirmed bookings will honor the original price.</li>
                                        <li>We reserve the right to cancel or reschedule courses due to unforeseen circumstances.</li>
                                        <li>Course materials and certificates will be provided upon successful completion.</li>
                                    </ul>
                                    
                                    <h3>Cancellation and Refund Policy</h3>
                                    <p>Cancellations made 30 days or more before the course start date are eligible for a full refund minus administrative fees. Cancellations made 15-29 days before receive a 50% refund. Cancellations made less than 15 days before the course start date are non-refundable. In case of course cancellation by Marsh Events & Training Hub, participants will receive a full refund or the option to transfer to another available course.
                                    </p>
                                    
                                    <h3>Intellectual Property</h3>
                                    <p>All course materials, content, and certificates provided by Marsh Events & Training Hub are our intellectual property. Participants may use the materials for personal learning purposes only and may not reproduce, distribute, or sell any content without our written permission.</p>
                                    
                                    <h3>Contact Us</h3>
                                    <p>For any questions regarding these Terms of Use, please contact us at info@marsheventsandtraininghub.com or call +44 7424 085130.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </div>

    )
}

export default TermsPage;